import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e918ea10"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "relative" }
const _hoisted_2 = ["name", "value", "id", "checked"]
const _hoisted_3 = ["for"]

import { computed, watch, ComputedRef } from "vue";
import { useGameStore } from "@/Store/useGameStore";

export default /*#__PURE__*/_defineComponent({
  __name: 'CheckBoxWithLabel',
  props: {
    value: {},
    name: {},
    is_required: { type: Boolean },
    modelValue: {},
    color: {},
    color2: {}
  },
  setup(__props: any) {

const gameStore = useGameStore();

const props = __props;

const valueString = computed(() => {
  return props.value.toString();
});

function updateCategories(event: Event) {
  const selectedCategoryId = props.value;
  const selectedCategoriesNew = [...props.modelValue];

  if (event.target instanceof HTMLInputElement) {
    const index = selectedCategoriesNew.indexOf(selectedCategoryId);
    if (event.target.checked && index === -1) {
      selectedCategoriesNew.push(selectedCategoryId);
    } else {
      if (index !== -1 && selectedCategoriesNew.length > 1) {
        selectedCategoriesNew.splice(index, 1);
      }
    }
    gameStore.updateSelectedCategories(selectedCategoriesNew);
  }
}

const gradientStyle = computed(() => {
  return `linear-gradient(to right, ${props.color}, ${props.color2}) 1`;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["border border-2 box-border text-md px-2 py-1 rounded-lg text-white", [{ 'background-custom': props.modelValue.includes(props.value) }]]),
      style: _normalizeStyle({
        borderImage: gradientStyle.value,
        '--gradient-color1': props.color,
        '--gradient-color2': props.color2,
      })
    }, [
      _createElementVNode("input", {
        type: "checkbox",
        name: props.name,
        value: props.value,
        id: valueString.value,
        onChange: updateCategories,
        checked: props.modelValue.includes(props.value)
      }, null, 40, _hoisted_2),
      _createElementVNode("label", {
        for: valueString.value,
        class: "cursor-pointer"
      }, _toDisplayString(props.name), 9, _hoisted_3)
    ], 6)
  ]))
}
}

})